import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import Grid from '@material-ui/core/Grid';
import StyledAvatar from 'components/StyledAvatar';
import Typography from '@material-ui/core/Typography';

const QuoteTypography = styled(Typography)`
  font-weight: normal;
  margin-bottom: 35px;
  line-height: 1.3em;
`;

const QuoteAvatar = styled(StyledAvatar)``;

class Quote extends React.PureComponent {
  render() {
    const { quote, align, size, hideImage, stacked } = this.props;

    return quote ? (
      <Grid
        container
        alignItems="flex-start"
        align={align}
        direction={align === 'right' ? 'row-reverse' : 'row'}
        justify="center"
        spacing={16}
        className={this.props.className}
      >
        {!hideImage && quote?.bio_image && (
          <Grid
            item
            xs={12}
            md={align === 'center' || stacked ? 12 : 2}
            align="center"
            data-swiftype-index="false"
          >
            <QuoteAvatar
              size={size === 'large' ? '135px' : '85px'}
              src={`${quote?.bio_image?.url}?format=pjpg&auto=webp${
                size === 'large' ? '&width=270' : '&width=170'
              }`}
            />
          </Grid>
        )}

        <Grid
          item
          xs={12}
          md={!hideImage && quote?.bio_image && !stacked ? 10 : null}
        >
          <QuoteTypography
            component="span"
            variant={size === 'large' ? 'display2' : 'headline'}
            gutterBottom
          >
            {quote.quote}
          </QuoteTypography>

          <Typography
            component="span"
            variant={size === 'large' ? 'title' : 'subheading'}
            gutterBottom
          >
            {quote.author_title}
          </Typography>

          <Typography
            variant="overline"
            component="span"
            color="textSecondary"
            gutterBottom
          >
            {quote.company}
          </Typography>
        </Grid>
      </Grid>
    ) : null;
  }
}

Quote.defaultProps = {
  size: 'large',
  align: 'left',
  hideImage: false
};

Quote.propTypes = {
  quote: PropTypes.shape({
    author_title: PropTypes.string.isRequired,
    bio_image: PropTypes.shape({
      url: PropTypes.string.isRequired
    }),
    company: PropTypes.string.isRequired,
    quote: PropTypes.string.isRequired
  }).isRequired,
  size: PropTypes.string,
  align: PropTypes.string,
  hideImage: PropTypes.bool
};

export default Quote;
